import request from '@/utils/request'

const getList = (data) => {
  const { name, authorName, translatorName, page, limit, sort } = data
  let query = `page=${page + 1}&limit=${limit}&sortBy=${sort.field}&orderBy=${sort.type}`

  if(name) query += `&name=${encodeURI(name)}`
  if(authorName) query += `&authorName=${encodeURI(authorName)}`
  if(translatorName) query += `&translatorName=${encodeURI(translatorName)}`

  return request({
    url: `/api/articles?${query}`,
    method: 'get'
  })
}

const update = (data) => {
  const { id } = data
  return request({
    url: `/api/articles/${id}`,
    method: 'patch',
    data
  })
}

const remove = (id) => {
  return request({
    url: `/api/articles/${id}`,
    method: 'delete'
  })
}

const detail = (id) => {
  return request({
    url: `/api/articles/${id}`,
    method: 'get'
  })
}

const download = () => {
  return request({
    url: `/api/articles/download`,
    method: 'get',
    responseType: 'blob'
  })
}

const ffmpegs = (id) => {
  return request({
    url: `/api/ffmpegs/split?bookId=${id}`,
    method: 'get'
  })
}

export default {
  getList,
  update,
  remove,
  detail,
  download,
  ffmpegs
}